export default __webpack_public_path__ + "static/media/img_logstash-colorBkg.5a353e5d.png";